import { render, staticRenderFns } from "./productInformation.vue?vue&type=template&id=5ee3217f&scoped=true"
import script from "./productInformation.vue?vue&type=script&lang=js"
export * from "./productInformation.vue?vue&type=script&lang=js"
import style0 from "./productInformation.vue?vue&type=style&index=0&id=5ee3217f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee3217f",
  null
  
)

export default component.exports